import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  // ManageCountries,
  DeleteRequestReviews,
  EditRequestReviews,
  GetRequestReviews,
} from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import { useLocation, useNavigate, useParams } from "react-router";

const RequestReviews = () => {
  const { country_id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [visaTypes, setVisaTypes] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  const [groupData, setGroupData] = useState([]);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);
  const location = useLocation();
  const dataCountry = location.state;

  const Schema = Yup.object().shape({
    name: Yup.string().trim().required("required"),
    image: Yup.string().trim().required("required"),
    stars: Yup.string().trim().required("required"),
  });

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetRequestReviews({
        country_id: country_id,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
          } else {
            setData([]);
          }
          setLoadingData(false);
        },
      })
    );
    if (array.length == 0) {
      setarray([
        {
          failed: "id",
          type: inputType.text,
          title: "id",
          placeholder: "",
          fullwidth: true,
          customdesign: { display: "none" },
        },
      ]);
    }
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.image, name: "client_image" },
    { type: columntype.text, name: "client_first_name" },
    { type: columntype.text, name: "client_last_name" },
    { type: columntype.text, name: "comment" },
    { type: columntype.text, name: "stars" },
    { type: columntype.date, name: "created_date" },
    { type: columntype.switch, name: "is_active" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: true,
    },
    {
      id: "client_image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: false,
    },
    {
      id: "client_first_name",
      numeric: false,
      disablePadding: false,
      label: "First name",
      withSort: false,
    },
    {
      id: "client_last_name",
      numeric: false,
      disablePadding: false,
      label: "Last name",
      withSort: false,
    },
    {
      id: "comment",
      numeric: false,
      disablePadding: false,
      label: "Comment",
      withSort: false,
    },

    {
      id: "stars",
      numeric: false,
      disablePadding: false,
      label: "stars",
      withSort: false,
    },
    {
      id: "created_date",
      numeric: false,
      disablePadding: false,
      label: "Created date",
      withSort: true,
    },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Active",
      withSort: true,
    },
    (dataPrivileges["4"]?.access_edit == 1 ||
      dataPrivileges["4"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = (dataGloble) => {
    return [
      dataPrivileges["4"]?.access_delete == 1 && {
        name: "Delete",
        function: async (row) => {
          if (row) {
            Commonalert.show({
              title: `Are you sure to delete ${row?.username ?? ""}?`,
              message: "You won't be able to revert this!",
              type: "delete",
              actions: [
                {
                  name: "Yes",
                  callback: () =>
                    dispatch(
                      DeleteRequestReviews({
                        callback: () => {
                          GetData({ tableName: null, type: null });
                        },
                        id: row.id,
                      })
                    ),
                  type: "delete",
                },
                {
                  name: "No",
                  callback: () => {},
                  type: "cancel",
                },
              ],
            });
          }
        },
      },
    ];
  };

  console.log({ array12313123123123: array });

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditRequestReviews({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };
  console.log({ data__123: data });
  return (
    <>
      <DynamicTable
        nameTable={dataCountry?.name}
        handleSearch={(event) => setSearch(event.target.value)} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(ListIds) => {
          console.log({ ListIds_123: ListIds });
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteRequestReviews({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: ListIds,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={(row) => List(row)} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={false}
        withDeleteItem={dataPrivileges["4"]?.access_delete == 1 ? true : false}
        withEditItem={dataPrivileges["4"]?.access_edit == 1 ? true : false}
        withPagination={false}
        withSearch={false}
        canBack
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Request Reviews"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new country"}
          buttonTitle={editMode ? "Edit" : "Add"}
          onChange={({ value, failedName, setFieldValue }) => {
            console.log({ value123: value });
            if (failedName == "group_id" && value == "-") {
            } else {
            }
          }}
          onSubmit={(valuess) => {
            // dispatch(
            //   ManageCountries({
            //     editMode: editMode,
            //     values: valuess,
            //     callback: (res) => {
            //       if (res) {
            //         setShowModal(false);
            //         GetData({ tableName: null, type: null });
            //       }
            //     },
            //   })
            // );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default RequestReviews;
